export default __webpack_public_path__ + "static/media/bali.2ce73723.jpg";